<template>
  <div v-if="isAvailable">
    <li class="tree__item">
      <div class="tree__action">
        <button type="button" class="tree__link" @click="toggleRightSidebar">
          <i class="tree__icon iconoir-sparks"></i>
          <span class="tree__link-text">{{
            $t('assistantSidebarItem.title')
          }}</span>
          <i
            v-show="rightSidebarOpen"
            class="tree__icon-right iconoir-view-columns-3"
          ></i>
        </button>
      </div>
    </li>
  </div>
</template>

<script>
export default {
  name: 'AssistantSidebarItem',
  emits: ['toggle-right-sidebar'],
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    rightSidebarOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasPermission() {
      return this.$hasPermission(
        'assistant.chat',
        this.workspace,
        this.workspace.id
      )
    },
    isConfigured() {
      return (
        this.workspace.ai_features?.kuma?.is_enabled ??
        !!this.$config.public.baserowEnterpriseAssistantLlmModel
      )
    },
    isAvailable() {
      return this.hasPermission && this.isConfigured
    },
  },
  watch: {
    isAvailable(available) {
      if (!available && this.rightSidebarOpen) {
        this.$bus.$emit('toggle-right-sidebar', false)
      }
    },
  },
  // Restoring the persisted open state is the region owner's job and is done in
  // `layouts/app.vue` when the shell initialises. It used to happen here, in
  // `mounted()`, which made restoration silently conditional on this list item
  // being rendered at all -- and therefore on an unrelated permission check --
  // and re-ran on every remount. Because the restore called the bus toggle with
  // no argument, each of those remounts inverted the state instead of restoring
  // it.
  methods: {
    toggleRightSidebar() {
      this.$bus.$emit('toggle-right-sidebar', !this.rightSidebarOpen)
    },
  },
}
</script>
